import Token, { TIPOS_TOKEN } from './Token';

// Token del editor de fórmula que almacena un valor numérico
// El valor es un decimal y lo mostramos con , en vez de .
export default class TokenVariable extends Token {
  constructor(valor) {
    super(TIPOS_TOKEN.NUMERO);
    this.decimal = false;
    this.label = '';
    this.valor = valor;
  }

  // eslint-disable-next-line class-methods-use-this
  siguienteValido(token) {
    if (token.valor === '(') {
      return false;
    }
    return token.tipo === TIPOS_TOKEN.OPERADOR;
  }

  concat(value) {
    if (value === ',') {
      if (this.decimal) {
        return;
      }
      // En este punto es que han dado a la coma sin tener ningún número
      // antes por lo que le ponemos el 0 directamente para facilitar
      if (this.label === '') {
        this.label = '0';
      }
      this.activarDecimal();
    } else {
      this.label = `${this.label}${value}`;
    }
  }

  get valor() {
    if (this.decimal) {
      return parseFloat(this.label.replace(',', '.'));
    }
    return parseInt(this.label, 10);
  }

  // Internamente usamos el label así que convertimos el valor
  // en su equivalente al label
  set valor(valorInicial) {
    let label = valorInicial?.toString().trim() || '';
    label = label.replace('.', ',');
    this.label = label;
    this.decimal = label.includes(',');
  }

  activarDecimal() {
    this.decimal = true;
    this.label = `${this.label},`;
  }
}
